import { Button, Image } from '@chakra-ui/react';
import { CodeResponse, useGoogleLogin } from '@react-oauth/google';
import { AuthType } from '@waitroom/models';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { SocialButtonProps } from '../types';
import googleImage from './google.svg';

const GoogleAuth = ({
  mutation,
  setLoading,
  loading,
  setError,
  onCompleted,
  redirectUrl,
  clientId,
  isSignup,
  state,
  codeChallenge,
  ...rest
}: SocialButtonProps): React.ReactElement | null => {
  const { t } = useTranslation();
  const isMounted = useRef(true);

  const googleLogin = useGoogleLogin({
    flow: 'auth-code',
    onSuccess: (response: CodeResponse) => {
      if (!isMounted) return;
      if (!('code' in response)) return;
      mutation.mutate({
        type: 'google',
        userDetails: {},
        code: response.code,
        redirectUrl,
        clientId,
        state,
        codeChallenge,
        onCompleted,
      });
      setLoading(undefined);
    },
    onNonOAuthError: () => {
      setError(false);
      setLoading(undefined);
    },
    onError: () => {
      setError(true);
      setLoading(undefined);
    },
  });

  const onClick = () => {
    setLoading(AuthType.GOOGLE);
    setError(false);
    googleLogin();
  };

  return (
    <Button
      isDisabled={loading === AuthType.APPLE}
      isLoading={loading === AuthType.GOOGLE || mutation.isPending}
      type="button"
      variant="outline"
      fontWeight="regular"
      color="gray.900"
      w="full"
      borderColor="gray.300"
      id={isSignup ? 'submit-google-signup' : 'submit-google-login'}
      leftIcon={<Image src={googleImage} alt="Google" w={6} h={6} mr={1} />}
      {...rest}
      onClick={onClick}
    >
      {t('auth.ssoGoogle')}
    </Button>
  );
};
export default GoogleAuth;
